var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pageSize" },
    [
      _c("span", [_vm._v(_vm._s(_vm.total) + " Records")]),
      _vm._v(" "),
      _c(
        "el-select",
        {
          attrs: { size: "small" },
          on: { change: _vm.sizeChange },
          model: {
            value: _vm.pageSize,
            callback: function($$v) {
              _vm.pageSize = $$v
            },
            expression: "pageSize"
          }
        },
        _vm._l(_vm.options, function(item) {
          return _c("el-option", {
            key: item,
            attrs: { label: item, value: item }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("span", [_vm._v(" Records per Page")]),
      _vm._v(" "),
      _c("el-pagination", {
        attrs: {
          background: "",
          layout: "prev, pager, next",
          "current-page": _vm.currentPage,
          "page-size": _vm.pageSize,
          total: _vm.total
        },
        on: { "current-change": _vm.currentChange }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07f22adf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f22adf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/pagination.vue
// module id = TsQG
// module chunks = 2